import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import { SecurityUtil } from '../../util';


@Component({
  selector: 'my-request-export-file-data-grid',
  templateUrl: './RequestExportFileDataGrid.component.html'
})
export class RequestExportFileDataGridComponent implements OnInit {

    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    exportFileData: ent.ExportFileData;
    frozenRecords: ent.ExportField[];
    cols: any[];
    customCols: any[];
    requestIDsCSV: string;
    requestIDs: number[] = [];
    activeIndex: number = 0;
    requests: ent.Request[] = [];
    displayPayloadDialog: boolean;
    payload: string;

    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private exportService: serv.ExportService, private requestService: serv.RequestService, private cdr: ChangeDetectorRef) 
    { 
      

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }
        this.userInfo = this.authenticationService.getUserInfo();
        //this.onSearchClick(null);
    }

    loadColumns(){
        //Note: this is only needed for the p-table exportCSV function to work. Without loading the columns, that will throw an error.
        this.cols = [
            { field: 'ID', header: 'ID' },
            { field: 'Sequence', header: 'Sequence' },
            { field: 'Header', header: 'Header' },
            { field: 'CONAHeader', header: 'CONA Header' },
            
        ];

    }

    public onSearchClick(event: any){
        
        this.requestIDs = [];
        var requestIDs = _.split(this.requestIDsCSV, ',');

        if (requestIDs.length == 0){
            return;
        }

        this.blockComponent.blocked = true;

        for (var id of requestIDs)
        {
            this.requestIDs.push(parseInt(id));
        }
        this.loadColumns();

        var requestFilter: filters.RequestFilter = {RequestIDs: this.requestIDs};
        this.requestService.getRequests(requestFilter).subscribe(requests => {
            this.requests = requests;
            this.exportService.getRequestGetExportFileData(this.requestIDs).subscribe(x=> {
                this.exportFileData = x;
                this.activeIndex = 0;
                //2020-04-17 LEB: The below line is needed because without it, the contents of the first tab are not shown until you click somewhere on the screen. Not sure why, but this fix works.
                this.cdr.detectChanges();
                this.blockComponent.blocked = false;
            }, err => {
                this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
                this.blockComponent.blocked = false;
            });
        }, err => {
            this.messageHandlerComponent.handleResponse({Success: false, ValidationMessages: [{Category: "error", MessageText: err}]})
            this.blockComponent.blocked = false;
        });

        
    }

    public getColumns(id: number): any[] {
        var cols: any[] = [];
        for (var col of this.cols){
            cols.push(col);
        }
        var exportFile = this.exportFileData.ExportFiles.filter(x=>x.ID == id)[0];
        if (exportFile) {
            for(var customCol of exportFile["MyCustomColumns"]) {
               cols.push({field: customCol, header: customCol});
            }
        }
        return cols;
    }

    showPayloadButtonForColumnHeader(myCustomColumn: string): boolean {
        var requestID = this.getRequestIDFromCustomColumn(myCustomColumn);
        if (requestID > 0){
            var request = this.requests.filter(x=>x.ID == requestID)[0];
            if (request.RequestType.SubmitUsingAPI){
                if (request.RequestTypeID != enums.RequestTypeEnum.PartnerFunctions){
                    return true;
                }
            }
        }
        return false;
    }

    showPayloadButtonForRow(requestID: number): boolean {
        if (requestID > 0){
            var request = this.requests.filter(x=>x.ID == requestID)[0];
            if (request.RequestType.SubmitUsingAPI){
                if (request.RequestTypeID == enums.RequestTypeEnum.PartnerFunctions){
                    return true;
                }
            }
        }
        return false;
    }



    onPayloadForEquipmentOrDriverClick(myCustomColumn: string) {
        var requestID = this.getRequestIDFromCustomColumn(myCustomColumn);


        if (requestID > 0){
            var request = this.requests.filter(x=>x.ID == requestID)[0];
            if (request) {
                if (request.RequestTypeID == enums.RequestTypeEnum.Driver) {
                    var payloadRequest: ent.CONADriverPayloadRequest = {MyCustomColumn: myCustomColumn, RequestID: requestID};
                    this.requestService.createCONAPayloadForDriver(payloadRequest).subscribe(x=> {
                        this.payload = x.Payload;
                        this.displayPayloadDialog = true;
                    });
                }
                else {
                    var payloadRequest: ent.CONAEquipmentPayloadRequest = {MyCustomColumn: myCustomColumn, RequestID: requestID};
                    this.requestService.createCONAPayloadForEquipment(payloadRequest).subscribe(x=> {
                        this.payload = x.Payload;
                        this.displayPayloadDialog = true;
                    });
        
                }
            }
            
        }
    }

    onPayloadForPartnerFunctionClick(requestID: number) {
        if (requestID > 0){
            var payloadRequest: ent.CONAPartnerFunctionPayloadRequest = {RequestID: requestID, PartnerType: ""};
            this.requestService.createCONAPayloadForPartnerFunction(payloadRequest).subscribe(x=> {
                this.payload = x.Payload;
                this.displayPayloadDialog = true;
            });
        }
    }

    getRequestIDFromCustomColumn(myCustomColumn: string): number{
        // myCustomColumn will be in the format: Request_2676_CoolerLineItem_149 Nbr1_of_1. 
        // The following logic tries to parse out the RequestID from that string
        var parts = myCustomColumn.split("_");
        if (parts.length > 1){
            var requestID = Number(parts[1]);
            return requestID;
        }
        return 0;
    }
    onHidePayloadDialog(event: any){
        this.displayPayloadDialog = false;
    }

    copyPayload(){
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = this.payload;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
      }

}